import axiosInstance from "../../routes/axiosConfig";

const denunciaService = {
  createPublic: async (payload) => {
    const { data } = await axiosInstance.post("/public/denuncias", payload);
    return data;
  },

  findAll: async () => {
    const { data } = await axiosInstance.get("/denuncias");
    return data;
  },

  updateStatus: async (id, status) => {
    const { data } = await axiosInstance.patch(`/denuncias/${id}/status`, {
      status,
    });
    return data;
  },

  delete: async (id) => {
    await axiosInstance.delete(`/denuncias/${id}`);
  },
};

export default denunciaService;
